import { NestedFormComponent } from '../../../../contexts/NestedFormControlContext/NestedFormComponent';
import { PatientInfoRefetchObj } from '../../../../contexts/PatientInfoContext/PatientInfoContext';
import { useUpdate, useUpdateListener } from '../../../../contexts/UpdateContext/UpdateContext';
import useDebounce from '../../../../hooks/useDebounce/useDebounce';
import { PatientService } from '../../../../services/PatientService';
import { ProblemsICDCodeContainer } from '../../../problems/container/ProblemsICDCodeContainer/ProblemsICDCodeContainer';
import { SymptomCardContainer } from '../../../symptom/container/SymptomCardContainer/SymptomCardContainer';
import { LabResultInCardComponent } from '../../../transcribing/component/LabResultTableComponent/LabResultInCardComponent';
import { WorklistBasicInformationComponent } from '../WorklistBasicInformationComponent/WorklistBasicInformationComponent';
import { WorklistContentComponent } from '../WorklistContentComponent/WorklistContentComponent';
import { WorklistMedicationComponent } from '../WorklistMedicationComponent/WorklistMedicationComponent';

export interface HealthRecordUpdateComponentProps {
  patientId: string;
  patientInfoService: PatientService;
  onSubmit?: (keys?: (keyof PatientInfoRefetchObj)[]) => void;
}

export const HealthRecordUpdateComponent = ({
  patientId,
  patientInfoService,
  onSubmit,
}: HealthRecordUpdateComponentProps) => {
  const workListUpdate = useUpdate('WORKLIST_UPDATED');
  const debouncedOnSubmit = useDebounce(() => onSubmit?.());
  const debouncedOnSubmitInsurance = useDebounce(workListUpdate.updateValue);
  useUpdateListener('INSURANCE_RENEWED', () => {
    onSubmit?.(['patientRefetch', 'patientInsuranceRefetch']);
  });
  return (
    <div className="flex fd-c gap5">
      <WorklistBasicInformationComponent
        patientId={patientId}
        patientInfoService={patientInfoService}
        onSubmit={debouncedOnSubmit}
        onSubmitInsurance={debouncedOnSubmitInsurance}
      />
      <NestedFormComponent>
        <WorklistContentComponent>
          <ProblemsICDCodeContainer
            patientId={patientId}
            title="ICD Code*"
            isEditing
            showEdit={false}
            formButtons={null}
            showHeaderOutside
          />
        </WorklistContentComponent>
      </NestedFormComponent>
      <WorklistMedicationComponent
        patientId={patientId}
        onSubmit={debouncedOnSubmit}
      />
      <SymptomCardContainer
        patientId={patientId}
      />
      <LabResultInCardComponent
        patientId={patientId}
      />
    </div>
  );
};
